import { useEffect, useState } from "react";
import "../ImageGalleryPage/ImageGalleryPage.css";
import PostApiCall from "../../../helper/PostAPI";
import CommonHomeNavbar from "../Navbar/CommonHomeNavbar";
import Footer from "../Footer/Footer";
import { Image } from "antd";
import { Helmet } from "react-helmet";

const ImageGalleryPage = () => {
  const [gallaryImages, setGallaryImages] = useState([]);
  useEffect(() => {
    PostApiCall.postRequest(
      {
        whereClause: `where fld_restaurant_id = '225736'`,
        columns: "*",
      },
      "getRestaurantImages"
    ).then((results) =>
      results?.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          setGallaryImages(obj.message);
          // Notiflix.Loading.Remove();
        }
      })
    );
  }, []);
  return (
    <>
      <CommonHomeNavbar />

      <Helmet>
        {/* meta tags */}
        <title>
          Gallery | Masala of India Cuisine | Best Indian Food in Northgate, Seattle - WA        </title>
        <meta
          name="description"
          content="View pictures of our restaurant Masala of India Cuisine in Northgate, Seattle - WA and the best authentic Indian Food that we serve."
        />
        <meta
          name="keywords"
          content="Masala of India Cuisine, Indian food Pictures, Indian restaurant Pictures, Restaurant Photo Gallery, Best Indian Restaurant in Northgate, Best Indian Restaurant in Seattle, Best Indian Restaurant in Washington - WA, Best Indian Food, Authentic Indian Food, Indian Lunch Buffet, Lunch Buffet, Tandoori Food, North Indian food in Seattle, Halal Food in Seattle, Halal Food in Northgate, North Indian Food, Indian Food Catering, Catering Services in Seattle, Best Catering Services in Seattle, Indian Restaurants near me, Lunch Buffet Near me, Best Indian Restaurant Near me, Sanjay Sharma, Chef Sanjay Sharma, Indian Ala carte Food, To-go Indian Food, Indian Food Delivery, Order Indian Food Online,
          diner, takeaway, indian takeaway, caterer, lunch restaurant, buffet restaurant, family restaurant, free dining restaurant, north indian restaurant, To-Go & Food Delivery, Online Ordering, Table reservations, Baby Showers, Bridal Showers, Rehearsal Dinner, Retirement, Greenwood, Seattle, WA, USA, Northgate, Seattle, WA, USA, Green Lake, Seattle, WA, USA, Maple Leaf, Seattle, WA, USA, Haller Lake, Seattle, WA, USA, Licton Springs, Seattle, WA, USA, Wedgwood, Seattle, WA 98115, USA, Pinehurst, Seattle, WA 98125, USA, Roosevelt, Seattle, WA 98115, USA, Victory Heights, Seattle, WA, USA, Bitter Lake, Seattle, WA 98133, USA, Morningside, Seattle, WA 98115, USA"
        />

        {/* OG tags */}
        <meta
          property="og:title"
          content="Gallery | Masala of India Cuisine | Best Indian Food in Northgate, Seattle - WA"
        />
        <meta
          property="og:description"
          content="View pictures of our restaurant Masala of India Cuisine in Northgate, Seattle - WA and the best authentic Indian Food that we serve."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.masalaofindia.com/gallery"
        />
        <meta
          property="og:image"
          content="https://www.masalaofindia.com/static/media/masala-of-india.c5a7d2004e43f4db1721.png"
        />
        <meta property="og:site_name" content="masala of india cuisine" />

        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Gallery | Masala of India Cuisine | Best Indian Food in Northgate, Seattle - WA"
        />
        <meta
          name="twitter:description"
          content="View pictures of our restaurant Masala of India Cuisine in Northgate, Seattle - WA and the best authentic Indian Food that we serve."
        />
        <meta
          name="twitter:image"
          content=" https://www.masalaofindia.com/static/media/masala-of-india.c5a7d2004e43f4db1721.png"
        />
        <meta name="twitter:site" content="masala of india cuisine" />

        <link rel="canonical" href="https://www.masalaofindia.com/gallery"></link>
      </Helmet>

      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="page-header-box">
                <h1 class="text-anime">Gallery</h1>
                <nav>
                  <ol class="breadcrumb wow fadeInUp" data-wow-delay="0.50s">
                    <li class="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li class="breadcrumb-item active">Gallery</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Gallary-images container my-4 my-lg-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="content">
              <div className="section-header">
                <h2>Explore the rich flavors of indian cuisine</h2>
                {/* <h3>Palate Pleasures</h3> */}
              </div>
            </div>
          </div>
          <Image.PreviewGroup>
            {gallaryImages?.map((data, index) => {
              const altText = data.fld_image_url.split('-')[1];
              return (
                <div className="col-4 mb-4">
                  <Image
                    id={index}
                    src={data.fld_image_url}
                    width="100%"
                    alt={altText}
                  ></Image>
                </div>
              );
            })}
          </Image.PreviewGroup>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ImageGalleryPage;
